import { Sv } from './Sv';

class MaterialsValue extends Sv {
    constructor() {
        super();
        this.baseUrl += '/materialsValue';
    }

    materialsValueList({ valueType, valueId } = {}) {
        return super.get('/materialsValueList', {
            valueType,
            valueId,
        });
    }

    materialsDetail({ valueType, valueId, materialsId } = {}) {
        return super.get('/materialsDetail', {
            valueType,
            valueId,
            materialsId,
        });
    }

    saveMaterials({ valueType, valueId, materialsId, materialsValue } = {}) {
        return super.post('/saveMaterials', {
            valueType,
            valueId,
            materialsId,
            materialsValue,
        });
    }

    materialsAudit({ materialsValueIds, materialsValueStatus } = {}) {
        return super.post('/materialsAudit', {
            materialsValueIds,
            materialsValueStatus,
        });
    }
}

export default new MaterialsValue();
export { MaterialsValue };
